<template>
<div class="chapter">
<div class="inner_page">
<p class="hr"><img alt="img" src="images/line-2.jpg"/></p>
<p class="center2"><span>E<span class="smallcaps">NTERED</span> according to Act of Congress, in the year 1876, by</span></p>
<p class="center2"><span>F. A. SCHWAB,</span></p>
<p class="center2"><span>In the office of the Librarian of Congress at Washington.</span></p>
<p class="hr1"><img alt="img" src="images/line-2.jpg"/></p>
<p class="hr2"><img alt="img" src="images/line-1.jpg"/></p>
<p class="indent">P<span class="smallcaps">RESS OF</span> W<span class="smallcaps">YNKOOP</span> &amp; H<span class="smallcaps">ALLENBECK,</span></p>
<p class="indent">       113 Fulton Street N.Y.</p>
<p class="hr3"><img alt="img" src="images/line-1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter2.vue?aaf0d082